import React, { useEffect, useState, useRef} from 'react' 
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import Home from './Home'
import Contactos from './Contactos'
import Sobre from './Sobre'
import Noticias from './Noticias'
import AreaPessoal from './AreaPessoal'
import Produtos from './Produtos'
import PoliPriva from './PoliPriva'
import PoliCookies from './PoliCookies'
import Eventos from './Eventos'
import useNewProds from './hooks/useNewProds'
import Portfolio from './Portfolio'
import UpcomingEvent from './UpcomingEvent'
import '../layout/Popups.Module.css'
import '../layout/Navbar.Module.css'
import logob from '../images/logos/logo-b.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faUser, faSearch, faAngleDown, faDownload, faArrowRight, faSignOut, faChevronLeft,faLightbulb, faL, faHeart } from '@fortawesome/free-solid-svg-icons'
import  $ from 'jquery'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { brochures, catalogos,catalogos_especiais,campanhas_especiais, flyers } from '../downloads'
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber'
import validator from 'validator'
import { ourBrands, reBrands} from '../brands'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import Projectos from './Projectos'
import GamaProdutos from './GamaProdutos'
import ProdDetail from './ProdDetail'
import {addToRecentView } from './ProdDetail';
import Noticia from './Noticia'
import ListProdus from './ListProdus'
import LoginModal from './LoginModal'
import LogoutModal from './LogoutModal'; 
import RedefinirSenha from './RedefinirSenha'; 
import emailjs from '@emailjs/browser'
import axios from 'axios';
import Recru from './Recru'
import DetalheEvento from './DetalheEvento'
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthContext';
import useScrollReveal from './hooks/useScrollReveal';
import TiltCard from './hooks/TiltCard'
import { fetchBrands, fetchRecommendedProducts } from '../api';
import { useLanguage } from './LanguageContext';
import { useCampanhas, CampanhaCard } from './hooks/useCampanhas'
import i18n from './i18n'

function Navbar({ onResetPage }){
  useScrollReveal(true);
  const [resetPageFlag, setResetPageFlag] = useState(false);
  const { t, i18n } = useTranslation('');
  const { user, logout, toggleFavorite, hasLoggedIn  } = useAuth();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const location = useLocation();
  
     useEffect(() => {
    if (user && hasLoggedIn) {
      const hasSeenPopup = sessionStorage.getItem('hasSeenPopup');
      if (!hasSeenPopup) {
        setIsPopupVisible(true);
        sessionStorage.setItem('hasSeenPopup', 'true'); // Set it here to ensure it won't show again
      }
    }
  }, [user, hasLoggedIn, location.pathname]);
  
  const closePopup = () => {
    setIsPopupVisible(false);
  };

useEffect(() => {
  // Permite que outras partes do app ativem o popup diretamente
  window.abrirPopupCampanhas = () => {
    setIsPopupVisible(true);
  };

  return () => {
    // Limpa para evitar vazamentos
    delete window.abrirPopupCampanhas;
  };
}, []);

  const handleProductClick = (idP, url) => {
    // Call your function and navigate to the URL
    twoFunctions(idP);
    navigate(url);
  };

  const twoFunctions =(id)=>{
    addToRecentView(id);
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showInfo, setShowInfo] = useState(false);
  const { selectedLanguage, changeLanguage } = useLanguage(); 
  const products = useNewProds(selectedLanguage);
const getInitials = name =>
  name
    .trim()
    .split(/\s+/) // divide por um ou mais espaços
    .map(word => word[0]?.toUpperCase() || '')
    .join('');

/**************Show submenu*******************/
useEffect(() => {
  // Remove handlers antigos para evitar duplicação

 $(document).off('click.menuItem');
  $(".menu__item:not(.not-page)").off('click').on('click.menuItem', function() {
    $(".menu__item").removeClass("menu__item-current");
    $(this).addClass("menu__item-current");
  });

  return () => {
    // Cleanup: remove listeners ao desmontar
    $(document).off('.menuItem .menuTitle');
  };
}, []);
  const closeSubmenu = () => {
    setActiveDropdown(null);
    // Ao definir activeDropdown como null, isSubmenuActive (calculado) 
    // torna-se false, e a classe "submenu-active" é removida.
};
/*********SubTabs************/
var brandLinks = document.querySelectorAll(".ourBrandsImgs");
var tabContent = document.querySelectorAll(".tabOurs");
brandLinks.forEach(function(el){
  el.addEventListener("click", setupBrandTabs)
})

var brandLinksRepre = document.querySelectorAll(".repreBrandsImgs");
var tabReContent = document.querySelectorAll(".tabRepre");
brandLinksRepre.forEach(function(el){
  el.addEventListener("click", setupBrandTabsRepre)
})

function setupBrandTabsRepre (el){
  var imgReTarget = el.currentTarget;
  var brandRe = imgReTarget.dataset.brand;
  tabReContent.forEach(function(el){
    el.classList.remove("tab-content-active");
  });

  brandLinksRepre.forEach(function(el){
    el.classList.remove("active")
  });

  document.querySelector("#"+brandRe).classList.add('tab-content-active');
  imgReTarget.classList.add("active");
}

document.addEventListener('DOMContentLoaded',()=>{
  setupBrandTabs();
  setupBrandTabsRepre();
})

/*************Show products categories ex:Fitas Profissionais, downlights ************** */
var subMenu_Brand = document.querySelectorAll(".submenu__inner");
var OursBrands = document.querySelectorAll(".brand-ours");
var RepreBrands = document.querySelectorAll(".brand-repre");

const width = window.innerWidth;
  if(width <= 1024){
    subMenu_Brand.forEach(function(el){
      el.addEventListener("click", showBrandCategory);
    })
}
function showBrandCategory(el){
  var getBrand = $(this).find('.brandsImgs').attr('data-brand');
  console.log("Current brand:"+ getBrand);
  OursBrands.forEach(function(el){
    console.log(el.dataset.nameb)
    el.classList.remove("showBrandCategories");
    if(getBrand === el.dataset.nameb){
    el.classList.add("showBrandCategories");
    }
  });
  RepreBrands.forEach(function(repre){
    repre.classList.remove("showBrandCategories");
    if(getBrand === repre.dataset.nameb){
      repre.classList.add("showBrandCategories");
    }
  });
}

 $('.category-list').on('click',function(){
  $('.brand-ours').removeClass("showBrandCategories");
  $('.brand-repre').removeClass("showBrandCategories");
});
/******************Responsive navbar************************/
/*********Open First Tab************/
const [isActive, setActive] = useState(false);
const [isOverlay, setOverlay] = useState(false);
const [isSub, setSubMenu] = useState(false);
const [activeDropdown, setActiveDropdown] = useState(null); // qual dropdown está aberto
const isSubmenuActive = activeDropdown !== null;
const TRANSITION_DURATION = 400;
const [activeTab, setActiveTab] = useState('ours');
const [isMenuVisible, setIsMenuVisible] = useState(false);
const toggleClass = () => {
  setActive(!isActive);
  setActiveDropdown(null);
};

const toggleDropdown = (dropdownName) => {
    setActiveDropdown(prevDropdown => {
        // Se o dropdown já estiver aberto, feche-o (null)
        if (prevDropdown === dropdownName) {
            return null;
        }
        // Caso contrário, abra o novo dropdown
        return dropdownName;
    });
};

const menuRef = useRef(null);
// Função para alternar a visibilidade do menu
  const toggleMenuVisibility = () => {
    // abrir submenu "brands"
    setIsMenuVisible(!isMenuVisible);
    setActiveDropdown(!isMenuVisible ? "brands" || "about" : null);
  };

// Função para fechar o menu
  const closeMenu = () => {
    setIsMenuVisible(false);
  };

  // Fechar ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    if (isMenuVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuVisible]);

/*************** Download catalogs and brochures ******************/
const [download, setDownload] = useState('');
function openModal(e){
  handleShow();
  setDownload(download => e)
}
// Name and company Validation
const form = useRef();
function handleDownload(e){
  e.preventDefault();
  if(formState.name==='' || formState.company===''){
    alert('Faltam campos a serem preencher');
  }

  else{
    console.log("Valor atual do download:"+ download)
    window.open(download, '_blank');
  }

  emailjs.sendForm('service_7uhtcll', 'template_a5wijz8', form.current, {
    publicKey: 'Hd9bXwR34y-Uu_Jb9',
  })
  .then(
    () => {
      console.log('SUCCESS!');
    },
    (error) => {
      console.log('FAILED...', error.text);
    },
  );
}

const phoneUtil = PhoneNumberUtil.getInstance();
const isPhoneValid = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};
// Email and Phone Validation
const validateEmail = (e) => {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var email = e.target.value
  if (!regex.test(email)) {
    setEmailError('Email inválido');
 } else {
    setEmailError('Email válido :)!');
 }
}

function handleInputChange(event) {
  const { name, value } = event.target;
  setFormState(prevState => ({ ...prevState, [name]: value }));
}

const [phone, setPhone] = useState('');
const isValid = isPhoneValid(phone)

const [emailError, setEmailError] = useState('');
const [formState, setFormState] = useState({ from_name: '', from_company: ''});

// Country and city select on downloads
const [data, setData] = useState([]);
const [getCountry, setCountry] = useState();
const [getState, setState] = useState([]);
const [selectedState, setSelectedState] = useState();

useEffect(() =>{
   axios.get('https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json')
  .then( (res) =>{ 
    setData(res.data);
   }
  )
  .catch(function (error) {
    console.log(error);
  })
  .then(function () {
    // always executed
  });
},[])

const country = [...new Set(data.map(item => item.country))];
country.sort();

const handleCountry =(e)=>{
  let states = data.filter(state => state.country === e.target.value);
 states = [...new Set(states.map(item=> item.subcountry))];
 states.sort();
 console.log(states);
 setState(states);
}

const handleState =(e)=>{
  let cities = data.filter(city => city.subcountry === e.target.value);
 cities = [...new Set(cities.map(item=> item.subcountry))];
 console.log(cities);
}
/**************Esqueçi a palavra passe**************** */
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
/*************************************************LOGOUT BUTTON****************************************/
const [showLogoutModal, setShowLogoutModal] = useState(false);

const handleLogout = () => {
  setShowLogoutModal(true); // Abre o modal de logout
};

const confirmLogout = () => {
  logout(); // Chama a função de logout
  setShowLogoutModal(false); // Fecha o modal de logout
};

const cancelLogout = () => {
  setShowLogoutModal(false); // Fecha o modal de logout
};
/*************************************************Change Login/Register modal****************************************/
const [login, setLogin] = useState(false);
const [showLogin, setShowLogin] = useState(false);
const [showRegister, setShowRegister] = useState(false);

const loginShow = () => setShowLogin(true);
const loginClose = () => setShowLogin(false);
const registerShow = () => setShowRegister(true);
const registerClose = () => setShowRegister(false);

const changeModal = () => {
  setShowLogin(false);
  setShowRegister(true);
};

const changeToLogin=()=>{
  setShowRegister(false);
  setShowLogin(true);
}

/*************** Open form pop up downloads******************/
const [show, setShow] = useState(false);
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
/*************** Pop up ******************/

const [searchBox, setSearchBox] = useState("");
const [isSearchOpen, setIsSearchOpen] = useState(false);
const searchRef = useRef(null);
const inputRef = useRef(null);

const navigate = useNavigate();
function handleSearch (){
  if(searchBox.trim().length !==0){
    navigate('/search-results/', {state:searchBox});
    setSearchBox('');
    setIsSearchOpen(false);
  }
}

function onKeypress(e){
  if(e.key === 'Enter'){
    handleSearch();
  }
}

const [brand, setBrand] = useState([])
useEffect(() => {
   fetchBrands().then(setBrand);
}, []);

/**********Show categories of products********** */
function setupBrandTabs (el){
  var imgTarget = el.currentTarget;
  var brand = imgTarget.dataset.brand;

  tabContent.forEach(function(el){
    el.classList.remove("tab-content-active");
  });

  /**************Não deixa todos os elementos coloridos**************** */
  document.querySelector("#"+brand).classList.add('tab-content-active');
}

const [activeOurBrand, setActiveOurBrand] = useState(
  ourBrands?.[0]?.name || null
);

const [activeReBrand, setActiveReBrand] = useState(
  reBrands?.[0]?.name || null
);

const [openLogin, setOpenLogin] = useState(false);

const openLoginModal = ()=>{
 setOpenLogin(!openLogin);
}

const languageMap = {
  pt: "pt",
  en: "en",
  es: "es",
  it: "it",
  fr: "fr",
  zh: "zh-CN",  // Map zh (i18n) to zh-CN (Google Translate)
};

const handleChangeLanguage = (lng) => {
  changeLanguage(lng);
  localStorage.setItem("language", lng);
  i18n.changeLanguage(lng);

  // Get the correct language code for Google Translate
  const googleLang = languageMap[lng] || lng;

  // Sync with Google Translate
  const googleTranslateDropdown = document.querySelector(".goog-te-combo");

  if (lng === "pt") {
    const iframe = document.querySelector("iframe.skiptranslate");
    if (iframe) {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      const originalButton = iframeDocument.getElementById(":1.restore");
      if (originalButton) {
        originalButton.click();
      } else {
        console.error("Show original button not found.");
      }
    }
  } else if (googleTranslateDropdown) {
    googleTranslateDropdown.value = googleLang;  // Use the mapped language
    googleTranslateDropdown.dispatchEvent(new Event("change"));
  }
};

useEffect(() => {
  const savedLanguage = localStorage.getItem('language') || 'pt';

  // Só aplica se o idioma salvo for diferente do idioma base
  if (savedLanguage && savedLanguage !== 'pt') {
    const interval = setInterval(() => {
      const googleTranslateDropdown = document.querySelector('.goog-te-combo');

      if (googleTranslateDropdown) {
        handleChangeLanguage(savedLanguage); // Usa sua função completa
        clearInterval(interval);
      }
    }, 300); // Tenta a cada 300ms até o dropdown carregar

    return () => clearInterval(interval);
  }
}, []);


const flagUrls = {
  pt: 'https://cdn.countryflags.com/thumbs/portugal/flag-800.png',
  en: 'https://cdn.countryflags.com/thumbs/england/flag-800.png',
  es: 'https://cdn.countryflags.com/thumbs/spain/flag-800.png',
  fr: 'https://cdn.countryflags.com/thumbs/france/flag-800.png',
  it: 'https://cdn.countryflags.com/thumbs/italy/flag-800.png',
  zh: 'https://cdn.countryflags.com/thumbs/china/flag-800.png'
};

const availableLanguages = Object.keys(flagUrls).filter(lng => lng !== selectedLanguage);

useEffect(() => {
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage && savedLanguage !== selectedLanguage) {
    changeLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage); 
  }
}, [selectedLanguage, changeLanguage, i18n]);

const [menuOpen, setMenuOpen] = useState(false);
const toggleMenu = () => {
    setMenuOpen(!menuOpen);
};

const containerRef = useRef(null); 
const toggleInfo = () => {
  setShowInfo(!showInfo);
};

  const popupRef = useRef(null);
  const scrollDown = () => {
    if (popupRef.current) {
      popupRef.current.scrollBy({
        top: 100, // valor em pixels pra descer, pode ajustar
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    // Toda vez que logar ou deslogar, garante que showInfo está falso
    setShowInfo(false);
  }, [user]);

  const today = new Date();

// Filtrar campanhas ativas
  const { campanhas, produtosPorCampanha, loading, error } = useCampanhas();
  if (loading) return null;
  if (error) return <div>Erro ao carregar campanhas: {error}</div>;
  const especiais = campanhas.filter(c => c.tipo === "especial");
  const lancamentos = campanhas.filter(c => !c.tipo || c.tipo.toLowerCase() === "lancamento");
  const todosProdutos = Object.values(produtosPorCampanha).flat();

const catalogosAntes = catalogos.filter(item => item.id <= 6);
const catalogosDepois = catalogos.filter(item => item.id > 6);
  return (
    <>
    <header className='header'>

     <nav className='navBar container-nav'>
     <section className="navbar__left">
        <Link to="/" className="brand"> <img src={logob} loading="lazy" className='logo' id='logo'></img> </Link>
        <div className="burger" id="burger" onClick={toggleClass}>
          <span className="burger-line" />
          <span className="burger-line" />
          <span className="burger-line" />
        </div>
    </section>

    <section className="navbar__center">
        <span onClick={toggleClass} className={`overlay-nav ${isActive ? 'is-active': ''}`}></span>
        <div id='menu-respon' className={`menu-respon ${isActive ? "is-active" : ""} ${isSubmenuActive ? "submenu-active" : ""}`}>
        <div className="menu__header">
          <span className="menu__arrow" onClick={closeMenu}><FontAwesomeIcon icon={faChevronLeft}/></span>
          <span className="menu__title"></span>
        </div>
        <ul className="menu">
        <li className='menu__item menu__item-current page'><Link to="/" id='house-icon' className='menu__link'><FontAwesomeIcon icon={faHome} onClick={toggleClass}/></Link></li>
        <li  className={`menu__item menu__dropdown brands ${activeDropdown === "brands" ? "menu__item-current show-submenu" : ""}`}>
          <a className='menu__link text-capitalize' onClick={() => toggleDropdown('brands')}>{t('navbar.marcas')}
            <FontAwesomeIcon className={`brandList ${activeDropdown === "brands" ? 'rotate' : ''}`} icon={faAngleDown} />
          </a>
        <div className= {`nav-dropdown brands submenu__list ${activeDropdown === "brands" ? 'visible' : ''}`} onMouseLeave={!isMobile ? () => activeDropdown === "brands" && setActiveDropdown(null) : undefined}>
        <div className='menu-title' onClick={closeSubmenu}><i className='fa-solid fa-chevron-left'></i> <h6>{t('navbar.marcas')}</h6></div>
        <ul className="indicator subMenu">
          <li className={activeTab === 'ours' ? 'active' : ''} onClick={() => setActiveTab('ours')} >
            <FontAwesomeIcon icon={faArrowRight}/>
            <span>{t('navbar.nMarca')}</span>
          </li>

          <li className={activeTab === 'repre' ? 'active' : ''} onClick={() => setActiveTab('repre')} >
            <FontAwesomeIcon icon={faArrowRight}/>
            <span>{t('navbar.rMarca')}</span>
          </li>

          <li className='seeAll not-tab'>
            <Link to="/produtos" onClick={toggleMenuVisibility}>
              {t('portifolio.tudo')} +
            </Link>
          </li>
        </ul>
        <ul className="content-brand subMenu">
          <li className={activeTab === 'ours' ? 'active' : ''} id="ours">
          <div className='subMenu-title'>
            <i className='fa-solid fa-chevron-left'></i>
            <h6>{t('navbar.mproprias')}</h6>
          </div>
            <div className='img-brands ours'>

            {ourBrands.map((b,i)=>(
            <div className='submenu__inner' key={i}>
                 <div className='submenu__logo '>
                 <img loading="lazy" className={`brandsImgs ourBrandsImgs ${activeOurBrand === b.name ? 'tab-content-active' : ''} ${activeOurBrand === b.name ? 'active' : ''}`} src={b.logoB} alt={b.marca} data-brand={`${b.name}`} onClick={()=> setActiveOurBrand(b.name)}/>
                 </div>
            </div>
            ))}
            
          </div>
          {ourBrands.map((item,index)=>(
          <div className='brand-ours' key={index} data-nameb={item.name}>
              <div className='category-list'>
                <i className='fa-solid fa-chevron-left'></i>
                <div className="image-title">
                  <img loading="lazy" src={item.linkImg}></img>
                </div>
              </div>
              <div className={`subTabCategory tabOurs ${activeOurBrand === item.name ? 'tab-content-active' : ''}`} key={index} id={item.name}>
                {item.category.map((type, index)=>(
                <Link to={`search-results/${item.name}/${type.name}`} key={index} onClick={toggleMenuVisibility} >
                <div className='typesProds' onClick={toggleClass} >
                 <LazyLoadImage src={type.linkImg}></LazyLoadImage>
                 <span className="title" style={{color: 'white'}}>{type?.nome[i18n.language]}</span>
                </div>
                </Link>
                ))}
              </div>
          </div>
            ))}
          </li>
      
        <li className={activeTab === 'repre' ? 'active' : ''} id="repre">
          <div className='subMenu-title'>
            <i className='fa-solid fa-chevron-left'></i>
            <h6>{t('navbar.mrepresen')}</h6>
          </div>
            <div className='img-brands repre' >
            {reBrands.map((item,index)=>(
              <div className={`submenu__inner`} key={index} >
               <div className='submenu__logo'>
               <img className={`brandsImgs repreBrandsImgs ${activeReBrand  === item.name ? 'tab-content-active' : ''}  ${activeReBrand === item.name ? 'active' : ''}`} src={item.logoB} alt={item.marca} data-brand={`${item.name}`} onClick={()=> setActiveReBrand(item.name)}/>
               </div>
              </div>
            ))}  
            </div>
            {reBrands.map((item,index)=>(
             <div className='brand-repre' key={index} data-nameb={item.name}>
               <div className='category-list'>
                  <i className='fa-solid fa-chevron-left'></i>
                  <div className="image-title">
                      <img loading="lazy" src={item.linkImg}></img>
                  </div>
              </div>
              <div className={`subTabCategory tabRepre ${activeReBrand  === item.name ? 'tab-content-active' : ''}`} key={index} id={item.name}>
                {item.category?.map((type, index)=>(
                  <Link to={`search-results/${item.name}/${type.name}`} key={index} onClick={toggleMenuVisibility}>
                    <div className="typesProds" onClick={toggleClass}>
                    <LazyLoadImage src={type.linkImg}></LazyLoadImage>
                    <span className="title" style={{color: 'white'}}>{type?.nome[i18n.language]}</span>
                    </div>
                  </Link>
                  ))}
              </div>
            </div>
            ))}
          </li>
        </ul>
        </div>
        </li>
        {/*menu-respon is-active + submenu-active */}
        {/*menu-respon is-active + submenu-active */}
        <li className='menu__item not-page'><a href='#popup1' className='menu_download'>{t('navbar.down')}</a></li>
        <li className='menu__item'><Link to="/noticias" className='menu__link' onClick={toggleClass}>{t('homepage.titleNoticias')}</Link></li>
        <li className='menu__item'><Link to="/portfolio" className='menu__link' onClick={toggleClass}>{t('navbar.portfolio')}</Link></li>
    
        <li className={`menu__item menu__dropdown about ${activeDropdown === "about" ? "menu__item-current show-submenu" : ""}`}>
          <a className='menu__link' onClick={() => toggleDropdown('about')}>{t('navbar.sobre')}<FontAwesomeIcon className={`icons fa fa-angle-down subLevel ${activeDropdown === "about" ? 'rotate' : ''}`} icon={faAngleDown}/></a>
        <div className= {`nav-dropdown about submenu__list`} >
          <div className='menu-title' onClick={closeSubmenu}>
          <i className='fa-solid fa-chevron-left'></i>
          <h6>{t('navbar.sobre')}</h6>
          </div>
          <ul className="nav-list">
            <li className='dropdown-ele'><Link to="/sobre-nos" className='' onClick={toggleClass}><i className="fa fa-info-circle"></i>{t('navbar.sobreN')}</Link></li>
            <li className='dropdown-ele'><Link to="/Contactos" className='' onClick={toggleClass}><i className="fa fa-phone"></i>{t('navbar.contactos')}</Link></li>
  
            <li className='dropdown-ele'><Link to="/eventos" className='' onClick={toggleClass}><i className="fa fa-calendar" aria-hidden="true"></i>{t('navbar.eventos')}</Link></li>
          </ul>
        </div>
        </li>

        <li className='menu__item not-page login-container'> 
            {/* Se o usuário estiver logado, mostrar o círculo com as iniciais */}
            {user ? (
              <>
              <button type="button" onClick={toggleInfo} className='menu__link show-desktop'>
                  {/* Círculo com as iniciais */}
                  <div className="user-initials-circle">  {getInitials(user.nome)} </div>
              </button><FontAwesomeIcon onClick={toggleInfo} className={`icons fa fa-angle-down subLevel show-desktop`} icon={faAngleDown}/>

            <li className="container mt-3 show-mobile menu__link">
                <button type="button" className='show-mobile' data-bs-toggle="collapse" data-bs-target="#login">
                    {/* Círculo com as iniciais */}
                    <div className="user-initials-circle"> {getInitials(user.nome)} </div>
                </button>
                {user.email && <p className='show-email' data-bs-toggle="collapse" data-bs-target="#login">{user.email} <FontAwesomeIcon className={`icons fa fa-angle-down subLevel`} icon={faAngleDown}/></p>}
            </li>
              <div id="login" className="collapse show-mobile">
                 <p><strong>{t('navbar.ola')},</strong> {user.nome}!</p>
                {/* <button className="personal-area"><Link to="/area-pessoal" className='menu__link'> <FontAwesomeIcon icon={faUser} />{t('apessoal.title')}</Link></button>*/}
                <button onClick={handleLogout} className="logout-button show-mobile">Logout</button>
              </div>
              </> ) : (
                // Caso contrário, mostrar o ícone de login
                <button type="button" onClick={loginShow} className='menu__link'>
                    <FontAwesomeIcon icon={faUser} />
                </button>
               )}

            {user && showInfo && (
              <div ref={containerRef} className="user-info-container show-desktop">
                  <p><strong>{t('navbar.ola')},</strong> {user.nome}!</p>
                  {/* Exibir o e-mail do usuário */}
                  {user.email && <p className='show-email'>{user.email}</p>}
                  {/* <button className="personal-area"><Link to="/area-pessoal" className='menu__link'> <FontAwesomeIcon icon={faUser} />{t('apessoal.title')}</Link></button>*/}
                  <button onClick={handleLogout} className="logout-button"><FontAwesomeIcon className={`icons fas fa-sign-out-alt`} icon={faSignOut}/>Logout</button>
              </div>
            )}
          </li>

        <li className='menu__item not-page language-picker'>
          <div id="select-container">
            <div id="current-flag" flow="down">
              <img loading="lazy" src={flagUrls[selectedLanguage]} alt={`Selected language: ${selectedLanguage}`} />
            </div>
            <ul>
              {availableLanguages.map(lng => (
                <li key={lng} lang-selection={lng.toUpperCase()} tooltip={lng.toUpperCase()} flow="down" onClick={() => handleChangeLanguage(lng)}>
                  <img loading="lazy" src={flagUrls[lng]} alt={`${lng} Flag`} width="50" />
                </li>
              ))}
            </ul>
          </div>
        </li>

        </ul>
        </div>
    </section>

   <section className="navbar__right">
    <div className='move-search-box' ref={searchRef}>
      <div className={`search-box ${isSearchOpen ? 'active' : ''}`}>
            <input  ref={inputRef} type="text" className="search-box-input" placeholder={t('navbar.searchbox')} value={searchBox} onChange={(e)=>setSearchBox(e.target.value)} onKeyUp={onKeypress}/>
            <button className="search-box-btn" onClick={() =>
              {if (isSearchOpen) { if (searchBox.trim().length !== 0) {
                  handleSearch(); } else {
                  setIsSearchOpen(false);  } } else {
                setIsSearchOpen(true); setTimeout(() => inputRef.current?.focus(), 0);
              }
            }}><FontAwesomeIcon className="search-box-icon material-icons" icon={faSearch} onClick={()=>{setIsSearchOpen(true);inputRef.current.focus();handleSearch()}}/></button>
      </div>
    </div>
    </section>

     </nav>
     <div>
    </div>
    {/*
      <button onClick={() => setIsPopupVisible(true)} className="popup-btn">
    {isMobile ? (
        <img src='/images/discount.svg' className="lightbulb-icon"/>
      ) : (
        <>
          Campanhas
          <FontAwesomeIcon icon={faLightbulb} className="lightbulb-icon" size='2x'/>
        </>
      )}
  </button>
    */}
    </header>

    {/*Pop up downloads*/}
  <div id="popup1" className="overlay">
      <div className="popup">
      <h1 className='main-heading mt-3'>{t('navbar.download')}</h1>
      <a className="close-btn fade-out main-btn-circle" href="#">X</a>
        <h2>{t('navbar.catalogos')}</h2>

      {/*Se usuário tiver conta não precisa fazer registro para acessar */}
        {user ? (
            <div id="gallery" className="photos-grid-container gallery">
              <div className="sub">
                {catalogosAntes.map((item, index) => (
                  <a href={item.download} download key={`cat-${index}`} className="img-box" target="_blank">
                    <img loading="lazy" src={item.linkImg} alt="image" />
                    <div className="item__details">
                      <div className="item__details_text">
                        {item.nameImg[i18n.language]} <FontAwesomeIcon icon={faDownload} />
                      </div>
                    </div>
                  </a>
                ))}

                {/* Catálogos especiais */}
                {user.can_view_special_catalogs && catalogos_especiais.map((item, index) => (
                  <a href={item.download} download key={`esp-${index}`} className="img-box" target="_blank">
                    <img loading="lazy" src={item.linkImg} alt="image" />
                    <div className="item__details">
                      <div className="item__details_text">
                        {item.nameImg[i18n.language]} <FontAwesomeIcon icon={faDownload} />
                      </div>
                    </div>
                  </a>
                ))}

                {/* Catálogos id 7 e 8 */}
                {catalogosDepois.map((item, index) => (
                  <a href={item.download} download key={`cat2-${index}`} className="img-box" target="_blank">
                    <img loading="lazy" src={item.linkImg} alt="image" />
                    <div className="item__details">
                      <div className="item__details_text">
                        {item.nameImg[i18n.language]} <FontAwesomeIcon icon={faDownload} />
                      </div>
                    </div>
                  </a>
                ))}
            </div>
          </div>
        ): (
          <div id="gallery" className="photos-grid-container gallery tabelas">
          <div className="sub">
           {catalogos.map((item, index) => (item.id === 4 ? (
              <div className="img-box"  onClick={() => {openModal(item.download); }} onChange={setDownload} key={index}>
                <img loading="lazy" src={item.linkImg} alt="image" />
                <div className="item__details"> 
                  <div className="item__details_text">
                    {item.nameImg[i18n.language]} <FontAwesomeIcon icon={faDownload} />
                  </div>
                </div>
              </div>
            ) : (
              <a href={item.download} download key={index} className='img-box' target='_blank'>
                <img loading="lazy" src={item.linkImg} alt="image" />
                <div className="item__details"> 
                  <div className="item__details_text">
                    {item.nameImg[i18n.language]} <FontAwesomeIcon icon={faDownload} />
                  </div>
                </div>
              </a>
            )
          ))}
        </div>
      </div>
        )}

        <h2>{t('navbar.brochuras')}</h2>
        <div className="brochuras-grid-container brochuras">
              <div className='sub'>
              {brochures.map((item, index)=>(
                <a href={item.download} key={index} target='_blank'>
                <img loading="lazy" src={item.linkImg} alt={item.nameImg[i18n.language]} />
                <div className="item__details"> 
                <div className="item__details_text">{item.nameImg[i18n.language]}</div>
                </div>
                </a>
              ))}
              </div>
        </div>

        <h2>{t('navbar.flyers')}</h2>
        <div className="brochuras-grid-container">
              <div className='sub'>
              {flyers.map((item, index)=>(
                <a href={item.download} download key={index}>
                <img src={item.linkImg} alt={item.nameImg[i18n.language]} />
                <div className="item__details"> 
                <div className="item__details_text">{item.nameImg[i18n.language]}</div>
                </div>
                </a>
              ))}
              </div>
          </div>
      </div>
    </div>
{campanhas.length > 0 && (
    <div id="popup2" className={`overlay popup-campanhas ${isPopupVisible ? 'popUpvisible' : ''}`}>
      <div className="popup"  ref={popupRef}>
        <a className="close-btn fade-out main-btn-circle" href="#" onClick={closePopup}>X</a>
          <div className='listacampanhas'>
          {especiais.length > 0 && (
          <div className="emvigor">
                <h2 className="scroll-top">{t('navbar.campanhas_especiais')}</h2>
                <div className="brochuras-grid-container campanhas">
                  <div className="sub">
                    {especiais.map(c => (
                      <CampanhaCard key={c.id} camp={c} i18n={i18n} />
                    ))}
                  </div>
                </div>
          </div>
         )}
          {/* 🟢 CAMPANHAS DE LANÇAMENTO */}
          <div className="lancamento">
            {lancamentos.length > 0 && (
              <>
                <h2 className="scroll-top">{t('navbar.campanhas')}</h2>
                <div className="brochuras-grid-container campanhas">
                  <div className="sub">
                    {lancamentos.map(c => (
                      <CampanhaCard key={c.id} camp={c}  i18n={i18n} />
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
         {todosProdutos.length > 0 && (
          <>
            <h2 className="mb-4 scroll-top">{t('homepage.novidades')}</h2>
            <div className="row g-4 prod-list-wrapper position-relative list-novidades" id="prod-list">
              {todosProdutos.map((item, index) => (
                <TiltCard className="col-20" key={item.idP}>
                  <div className="shop__thumb">
                    <h6 className="novidades-button">{t('pdetail.novo')}</h6>
                    <Link to={`/prodetail/${encodeURIComponent(item.nome.replace(/\s+/g, '-').toLowerCase())}/${item.idP}`}
                      target="_blank" onClick={(e) => { e.preventDefault();
                        const link = `/prodetail/${encodeURIComponent(item.nome.replace(/\s+/g, '-').toLowerCase())}/${item.idP}`;
                        window.open(link, '_blank'); }} >
                      <div className="shop-thumb__img">
                        <img src={item.imgP} className="img-responsive" alt={item.nome} />
                      </div>
                      <h3 className="shop-thumb__title pnome translate"><b>{item.nome}</b></h3>
                      <h5 className="shop-thumb-brand b-name">{item.marca}</h5>
                      <h5 className="shop-thumb-brand ref-pvp">
                        <div className="ref-block">
                          <span className="references">Ref:</span>&nbsp;
                          {item.prodEspe}
                        </div>
                        <div className="pvp-text">
                          <span className="references">P.V.P.</span>
                        </div>
                      </h5>
                      <div className="ip-pvp-container">
                        {item?.ip && (
                          <span className="shop-thumb-brand second-block">
                            <span className="no-bold">IP {item.ip}</span>
                          </span>
                        )}
                        <span className="pvp-value">
                          {item.pvp ? `${parseFloat(item.pvp).toFixed(2)}€` : ''}
                        </span>
                      </div>
                    </Link>
                  </div>
                </TiltCard>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
)}

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Download</Modal.Title>
      </Modal.Header>
    <Modal.Body>

    <form ref={form} className="form-download row g-3 needs-validation" noValidate onSubmit={handleDownload} method='POST'>
      <div className="mb-1">
      <label className="form-label">{t('contactos.nome')}: <span>*</span></label>
      <input type="text" name="from_name" value={formState.name} onChange={handleInputChange} className="form-control" required/>
    </div>

    <div className="mb-1">
      <label className="form-label">Email: <span>*</span></label>
      <input type="email" onChange={(e) => validateEmail(e)} className="form-control" required name='from_email'/>
      <span style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
    </div>

    <div className="mb-1">
    <label className="form-label">{t('download.pais')}: <span>*</span></label>
      <select onChange={(e)=> handleCountry(e) } className="form-control" name='from_country'>
          {country.map(items=> <option key={items} value={getCountry}>{items}</option>)}
      </select>
    </div>

    <div className="mb-1">
    <label className="form-label">{t('recru.cidade')}: <span>*</span></label>
      <select onChange={(e)=> handleState(e) } className="form-control" name='from_city'>
          {getState.map(items=> <option key={items} value={selectedState}>{items}</option>)}
      </select>
    </div>

    <div className="mb-1">
      <label className="form-label">{t('download.empresa')}: <span>*</span></label>
      <input type="text" name="from_company" value={formState.company} onChange={handleInputChange} className="form-control"  />
    </div>

    <div className="mb-1">
      <label className="form-label">{t('recru.tele')}: <span>*</span></label>  
    <PhoneInput defaultCountry="pt" value={phone} onChange={(phone) => setPhone(phone)} name='from_phone'/>
    {!isValid && <div style={{ color: 'red' }}>{t('download.invalid')}</div>}
    </div>
    
      <div className="col-12">
        <button className="btn btn-primary sub-btn" type="submit" disabled={!isValid ||
          formState.from_name.length <5 || formState.from_company.length <4  || emailError !== 'Email válido :)!' || getState === ''}>{t('download.descar')}</button>
      </div>
    </form>

      </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>{t('download.fechar')}</Button>
        </Modal.Footer>
      </Modal>

    {/*Pop up login*/}
    <LoginModal 
        login={showLogin} 
        loginClose={loginClose} 
        loginShow={loginShow}
        register={showRegister}
        registerClose={registerClose}
        registerShow={registerShow}
        changeModal={changeModal}
        changeToLogin={changeToLogin}/>

      {/* Modal de Confirmação de Logout */}
     <LogoutModal 
        show={showLogoutModal} 
        onHide={cancelLogout} 
        onConfirm={confirmLogout} />
   <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/produtos' element={<Produtos/>}/>
        <Route path='/Contactos' element={<Contactos/>}/>
        <Route path='/sobre-nos' element={<Sobre/>}/>
        <Route path='/noticias' element={<Noticias/>}/>
        <Route path='/noticia/:id' element={<Noticia/>}/>
        <Route path='/matelec2025' element={<UpcomingEvent/>}/>
        <Route path='/eventos' element={<Eventos/>}/>
        <Route path='/portfolio' element={<Portfolio/>}/>
        <Route path='/projectos/:name' element={<Projectos/>}/>
        <Route path='/:name' element={<GamaProdutos/>}/>
        <Route path='/prodetail/:nome/:id' element={<ProdDetail/>}/>
        <Route path='/search-results/:brand?/:category' element={<ListProdus/>}/>
        <Route path='/search-results' element={<ListProdus/>}/>
        <Route path='/candidatura-espontanea/' element={<Recru/>}/>
        <Route path='/evento/:name' element={<DetalheEvento/>}/>
        <Route path='/area-pessoal' element={<AreaPessoal/>}/>
        <Route path='/politica-de-privacidade/' element={<PoliPriva/>}/>
        <Route path='/politica-de-cookies/' element={<PoliCookies/>}/>
        <Route path="/redefinir_senha/:token" element={<RedefinirSenha />} />
    </Routes>
    </>
  )
}

export default Navbar
